(ns frontend.ui.component.lp-portal.report.company.money-multiple-distribution-chart.controller
  (:require
   [frontend.ui.component.chart.utils :as chart-utils]
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.style.theme.core :as theme]
   [frontend.utils :as fu]))

{:ordered-cols   ["Color" "2021" "2022"]
 :col-data-types [:string nil nil]
 :title          "Name"
 :data           [{:row-style       {:data-format-string "General"}
                   :next-empty?     false
                   :cell-styles     [{:data-format-string "General"} {:data-format-string "General"}
                                     {:data-format-string "General"}]
                   :cell-data-types [:string :number :number]
                   :row-data-type   nil
                   :row-key         "Money Multiple Fair Value"
                   :row-data        ["#AAABBB" 0.981938355493965 0.981938355493965]}
                  {:row-style       {:data-format-string "General"}
                   :next-empty?     false
                   :cell-styles     [{:data-format-string "General"} {:data-format-string "General"}
                                     {:data-format-string "General"}]
                   :cell-data-types [:string :number :number]
                   :row-data-type   nil
                   :row-key         "Money Multiple Realised proceeds"
                   :row-data        ["#BBBAAA" 0.981938355493965 0.981938355493965]}]}

(defn config->editable-data
  [config]
  (let [axis (->> config
                  :yAxis)]
  {:columns       (some->> config
                           :xAxis
                           :categories
                           (vec))
   :data          (->> config
                       :series
                       (mapv (fn [serie]
                               (vec (concat [(:name serie)]
                                            (->>
                                              (:data serie)
                                              (map (fn [point]
                                                     (:y point)))))))))
   :configured-colors (->> config
                           :series
                           (mapv (fn [serie]
                                   (:color serie))))
   :y-axis-config (chart-utils/config->editable-y-axis-data config)}))

(defn editable-data->raw-data
  [edited-data]
  (merge {:ordered-cols (concat ["Color"] (:columns edited-data))}
         {:data
          (->> edited-data
               :data
               (keep-indexed (fn [idx row]
                               (let [row-key (first row)
                                     number-data (->> (rest row)
                                                      (mapv (fn [v]
                                                             (when (number? v) v))))]
                                 {:row-key  row-key
                                  :row-data (concat [(nth (:configured-colors edited-data) idx)] number-data)}))))}))

(defn chart-config
  [data]
  (let [color-col-index (->> data
                             :ordered-cols
                             (map-indexed (fn [idx heading]
                                            (when (= heading "Color")
                                              idx)))
                             (remove nil?)
                             (first))
        category-names (if color-col-index
                         (concat (take color-col-index (:ordered-cols data))
                                 (drop (inc color-col-index) (:ordered-cols data)))
                         (:ordered-cols data))
        series-data (->> data
                         :data
                         (map (fn [row]
                                (let [raw-data (:row-data row)
                                      row-data (if color-col-index
                                                 (concat (take color-col-index raw-data)
                                                         (->> raw-data
                                                              (drop (inc color-col-index))))
                                                 raw-data)]
                                  (merge {:name (:row-key row)
                                          :data (->> row-data
                                                     (mapv (fn [y]
                                                             {:y     y
                                                              :color (nth raw-data color-col-index)
                                                             })))}
                                         (when color-col-index
                                           {:color (nth raw-data color-col-index)}))))))
        y-axis-1 (chart-utils/resolve-editable-axis-data (first (:y-axis-config data)) nil "Money multiple")]
    {:chart       {:type "column"}
     :tooltip     {:outside         true
                   :useHtml         true
                   :backgroundColor (theme/color [:page-bg :bg])
                   :style           {:opacity         1
                                     :backgroundColor (theme/color [:page-bg :bg])}
                   :enabled         false}

     :plotOptions {:series {:stacking     "normal"
                            :colorByPoint false
                            :borderWidth  0
                            :dataLabels   {:enabled   true
                                           :inside    true
                                           ;:verticalAlign "top"
                                           :style     {:color       "contrast"
                                                       :textOutline false}
                                           :formatter (fn [arg]
                                                        (this-as
                                                         js-data-point
                                                         (let [point (js->clj js-data-point
                                                                              :keywordize-keys
                                                                              true)]
                                                           (str (util/->float-2-decimals
                                                                 "x"
                                                                 (fu/absolute-float (:y
                                                                                     point)))))))}}}
     :legend      {:enabled true}
     :xAxis       {:type          "category"
                   :categories    category-names
                   :lineColor     (theme/color [:chart :x-axis :line])
                   :gridLineColor (theme/color [:chart :x-axis :grid-line])}
     :yAxis       [{:visible       true
                   :title         {:text (:title-text y-axis-1)}
                   :labels        {:formatter (:formatter-fn y-axis-1)}
                   :lineColor     (theme/color [:chart :y-axis :line])
                   :gridLineColor (theme/color [:chart :y-axis :grid-line])}]
     :series      series-data}))
